import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AnswerTextExecution} from '../../../data/models/execution/answer-execution';
import {AnswerExecutionService} from '../../../services/api/execution/answer-execution.service';
import {FormBuilder, FormGroup, ValidatorFn} from '@angular/forms';
import {ANSWERED_TEXT_VALIDATORS, ANSWER_TEXT_VALIDATORS} from '../../../../constants/validators';
import {AnswerExecution} from '../answer-execution';

@Component({
  selector: 'app-answer-text-execution',
  templateUrl: './answer-text-execution.component.html',
  styleUrls: ['./answer-text-execution.component.css']
})
export class AnswerTextExecutionComponent implements OnInit, OnChanges, AnswerExecution {

  readonly ANSWERED_TEXT_VALIDATORS = ANSWERED_TEXT_VALIDATORS;

  @Input() executionId!: number;
  @Input() questionId!: number;
  @Input() text!: AnswerTextExecution;
  @Input() required = true;

  @Output() textChange = new EventEmitter<AnswerTextExecution>();

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private answerExecutionService: AnswerExecutionService,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      text: [this.text.text, this.getValidators()],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.form && changes.questionId) {
      this.form.controls.text.setValue(this.text.text);
      this.form.controls.text.markAsPristine();
      this.form.controls.text.markAsUntouched();
      this.form.controls.text.updateValueAndValidity();
    }
    if (this.form && changes.required) {
      this.form.controls.text.setValidators(this.getValidators());
      this.form.controls.text.updateValueAndValidity();
    }
  }

  submitAnswer(): Promise<void> {
    const textControl = this.form.controls.text;
    const value = textControl.value ?? '';
    const normalizedValue = typeof value === 'string' ? value : '';
    const trimmedValue = normalizedValue.trim();

    if (this.required && textControl.invalid) {
      textControl.markAsTouched();
      textControl.updateValueAndValidity();
      return Promise.reject(new Error('answer-text-validation-error'));
    }

    if (!this.required) {
      if (textControl.invalid) {
        textControl.markAsTouched();
        textControl.updateValueAndValidity();
        return Promise.reject(new Error('answer-text-validation-error'));
      }

      if (trimmedValue.length === 0) {
        if (normalizedValue.length > 0) {
          textControl.setValue('');
        }
        if (this.text?.text && this.text.text.length > 0) {
          return this.answerExecutionService.updateAnswerText(this.executionId, this.questionId, {
            text: '',
          }).then(text => {
            this.textChange.emit(text);
          });
        }
        return Promise.resolve();
      }
    }

    if (this.form.controls.text.value !== this.text.text) {
      return this.answerExecutionService.updateAnswerText(this.executionId, this.questionId, {
        text: this.form.controls.text.value,
      }).then(text => {
        this.textChange.emit(text);
      });
    }
    return Promise.resolve();
  }

  private getValidators(): ValidatorFn[] {
    return this.required ? this.ANSWERED_TEXT_VALIDATORS.TEXT : ANSWER_TEXT_VALIDATORS.TEXT;
  }

}
